import instanceAPI from 'services/apis/axiosconfig';

const axiosConfig = {
  withCredentials: true,
};

export const postShoppingCart = (data) => {
  const request = instanceAPI.post('/private/purchase', data, axiosConfig);
  return request.then((res) => res).catch((error) => error);
};
